module.exports = __webpack_public_path__ + "img/no-wifi-icon.d19c7f43.svg";